import * as React from 'react'
import { bind } from 'classnames/bind'
import * as stylesFlex from '@procore/core-css/src/layouts/_flex.scss'
import * as stylesBox from '@procore/core-css/src/layouts/_box.scss'

import { Props, AccessibleProps, DivAttributes } from '../utils/types'
import Box, {
  FlexAlignNS,
  FlexDirection,
  FlexDirectionNS,
  FlexJustifyNS,
  FlexWrap,
  FlexOptions,
  MarginOptions,
  PaddingOptions,
} from './Box'

export interface FlexProps
  extends Props,
    FlexOptions,
    MarginOptions,
    PaddingOptions,
    AccessibleProps {
  direction?: FlexDirection
  inline?: boolean
  flex?: string
  basis?: string
  grow?: string
  shrink?: string
  wrap?: FlexWrap
  order?: number
}

const cx = bind({ ...stylesBox, ...stylesFlex })

const Flex = React.forwardRef<HTMLDivElement, DivAttributes & FlexProps>(
  (
    {
      alignItems = FlexAlignNS.start,
      basis,
      className,
      direction = FlexDirectionNS.row,
      inline = false,
      justifyContent = FlexJustifyNS.start,
      grow,
      shrink,
      wrap,
      ...props
    },
    ref
  ) => {
    return (
      <Box
        ref={ref}
        className={cx(
          { [`core-flex-inline-${direction}`]: inline },
          { [`core-flex-${direction}`]: !inline },
          className
        )}
        alignItems={alignItems}
        justifyContent={justifyContent}
        flexBasis={basis}
        flexGrow={grow}
        flexShrink={shrink}
        flexWrap={wrap}
        {...props}
      />
    )
  }
)

Flex.displayName = 'Flex'

export default Flex
